import React from 'react';

const ImpactTab = ({ impact }: { impact: string }) => {
  return <div className="product-tab-content">{impact}</div>;
};

export default ImpactTab;
